import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export type LoginFlow = 'cognito' | 'migrate' | 'stytch';

export interface MigrationResponse {
  login_flow: LoginFlow;
  email: string;
  apple_login: boolean;
}

@Injectable({ providedIn: 'root' })
export class MigrationService {
  private readonly http = inject(HttpClient);

  checkEmail$(email: string): Observable<MigrationResponse> {
    return this.http.post<MigrationResponse>('/login_check', { email });
  }
}
